mutation UpdateNewsItem(
  $newsItemId: ID!
  $newsItemChanges: NewsItemChangeInput!
) {
  updateNewsItem(
    input: { newsItemId: $newsItemId, newsItemChanges: $newsItemChanges }
  ) {
    newsItem {
      id
    }
  }
}
